import type { UserFormSchema, UserFormSchemaForExternalUser } from '../schema';

// TODO: move this to the mutation file when implementing BE connection
type CreateUserVariables = {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  jobTitle: string;
  organization?: string;
  isInternal: boolean;
  roles: {
    [k: string]: {
      labels: Array<{
        id: string;
        name: string;
      }>;
      labelGroups: Array<{
        id: string;
        name: string;
      }>;
    };
  };
};

export const mapFormDataToApi = (
  data: UserFormSchema | UserFormSchemaForExternalUser,
): CreateUserVariables => {
  const res: CreateUserVariables = {
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    phone: data.phone,
    jobTitle: data.jobTitle,
    isInternal: data.userType === 'internal',
    roles: {},
  };

  if (data.userType === 'internal') {
    res.organization = data.organization;
    for (const role of data.internalPermissions.roles) {
      res.roles[role.value] = {
        labels: [],
        labelGroups: data.internalPermissions.labelGroups.map((labelGroup) => ({
          id: labelGroup.value,
          name: labelGroup.label ?? '',
        })),
      };
    }
  } else {
    for (const { role, labels } of data.externalPermissions) {
      res.roles[role] = {
        labels: labels.map((label) => ({
          id: label.value,
          name: label.label ?? '',
        })),
        labelGroups: [],
      };
    }
  }

  return res;
};
